module.exports = __webpack_public_path__ + "img/bg.e1e1f5de.jpg";